/**
 * Load iframes only when they enter the viewport (load on scroll).
 * Use data-lazy-src instead of src on iframes; this script sets src when in view.
 * Preserves theme behavior: iframe works the same once visible.
 */
(function () {
  if (typeof window.IntersectionObserver === 'undefined') return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const iframe = entry.target;
        const src = iframe.getAttribute('data-lazy-src');
        if (src) {
          iframe.setAttribute('src', src);
          iframe.removeAttribute('data-lazy-src');
          observer.unobserve(iframe);
        }
      }
    },
    { rootMargin: '100px', threshold: 0 }
  );

  function observeLazyIframes() {
    document.querySelectorAll('iframe[data-lazy-src]').forEach((el) => observer.observe(el));
  }

  observeLazyIframes();

  document.addEventListener('shopify:section:load', () => observeLazyIframes());
})();
